<template>
          <!-- contents -->
          <div id="contents">
            <div class="contents_wrap">
              <!-- contents_head -->
              <!-- breadcrumbs -->
              <skp-breadcrumbs @page-title="val => pageTitle = val" />
              <!-- //breadcrumbs -->
              <h2 class="pg_title">{{ pageTitle }}</h2>
              <!-- //contents_head -->

              <!-- srchTop_wrap -->
              <div class="srchTop_wrap">
                <article class="srch_basic">
                  <div class="srch_grup">
                    <ul class="w50">
                        <li class="tit_150">{{$t('FIELD.GLOBAL.PERIOD')}} <em class="txt_mandatory">*</em></li>
                        <dd data-input-type="date">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input id="fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                        <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="from-picker-container" style="margin-top: -1px;"></div>
                                </span>
                                <em class="txt_space"></em>
                                <span class="date-wrap">
                                    <label>
                                        <input id="toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                        <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;"></div>
                                </span>
                            </fieldset>
                        </dd>
                    </ul>                
                  </div>
                  <div class="srch_grupR_bottom">
                    <span class="btn">
                      <a href="javascript:" class="btn_srch" @click="onSearch()">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                    </span>
                  </div>
                </article>
              </div>
              <!-- Grid -->
              <!-- Grid -->
              <div class="grid_wrap">
                <div class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ totalCount | numberFormat }}</em></div>
                <div class="btn_wrap">
                    <a href="javascript:" class="btn_white" @click="excelDownload()">{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    :data="gridData"
                    ref="GridId"
                    :columns="columns"
                    :options="options"
                    :header="gridHeader"
                    :key="gridKey"
                    :pageOptions="pageOptions"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div>
            <!-- <div class="paginate">
                <sdl-pagination
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="search"
                    align="center"
                />
             </div> -->
            </div>
          </div>
          <!-- contents -->

</template>

<script>
import Vue                      from 'vue';
import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import $                        from 'jquery';
import qs                       from 'query-string';
import axios                    from 'axios';
import moment                   from 'moment';
import { SDLUtil, DateUtil }    from '@/utils';
import SKPBreadcrumbs           from '~vb/main/SKPBreadcrumbs';
import DatePicker               from '~c/DatePicker';
import ToastGrid                from '~c/ToastGrid';
import ExcelDownloadPopup       from '~vb/common/ExcelDownloadPopup';
import StstLinkPopup            from './StstLinkPopup';

require('moment-jdateformatparser');

// 메인 목록 조회
const fetchGridData = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/statisticsManager/qnaSatisIndexByGBMList.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// ToastGrid  renderer
class ClassRenderer {
    constructor(props) {
        let rowKey = props.rowKey;
        let colVal = props.grid.store.data.rawData[rowKey].PROD_NM;
        let resVal = props.value;
        const el = document.createElement('span');
        if (colVal == 'Total') {
            el.className = "subTotal";
        } else if (resVal > 0) {
            el.className = "ftColor";
        }
        el.innerText = resVal;
        this.el = el;
    }
    getElement() {
        return this.el;
    }
};

export default {
    name : 'UnreadList',
    props : {

    },
    data() {
        return {
            isProcess: true,

            FROM_DATE: {},     // Knowledge date
            TO_DATE: {},       // View date

            pageTitle : '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            totalCount : 0,
            gridId : "GridId",
            gridKey: 0,
            gridData : [],
            gridHeader: {
                height: 60,
                complexColumns: [
                    {
                        header: SDLUtil.getMsgProp('FIELD.GLOBAL.ANSWERSATISFACTION'),
                        name: 'mergeColumn1',
                        childNames: ['TOTAL_CNT', 'VERY_GOOD_CNT', 'GOOD_CNT', 'NORMAL_CNT', 'BAD_CNT', 'VERY_BAD_CNT', 'NO_POLL_CNT', 'SCORE']
                    }
                ]
            },
            columns : [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.GBM'),
                    name: "PROD_NM",
                    align: "left",
//                    width: "*",
                    sortable: false,
                    resizable: true
                },
                {
                    header: 'GBM_CD',
                    name: "GBM_CD",
                    hidden: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL'),
                    name: "TOTAL_CNT",
                    align: "center",
                    width: 100,
                    renderer: { type: ClassRenderer },
                    sortable: false,
                    resizable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.VERYGOOD'),
                    name: "VERY_GOOD_CNT",
                    align: "center",
                    width: 100,
                    renderer: { type: ClassRenderer },
                    sortable: false,
                    resizable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.GOOD'),
                    name: "GOOD_CNT",
                    align: "center",
                    width: 100,
                    renderer: { type: ClassRenderer },
                    sortable: false,
                    resizable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.NORMAL'),
                    name: "NORMAL_CNT",
                    align: "center",
                    width: 100,
                    renderer: { type: ClassRenderer },
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.BAD'),
                    name: "BAD_CNT",
                    align: "center",
                    width: 100,
                    renderer: { type: ClassRenderer },
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.VERYBAD'),
                    name: "VERY_BAD_CNT",
                    align: "center",
                    width: 100,
                    renderer: { type: ClassRenderer },
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.ADMIN.NO.POLL'),
                    name: "NO_POLL_CNT",
                    align: "center",
                    width: 100,
                    renderer: { type: ClassRenderer },
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.SCORE'),
                    name: "SCORE",
                    align: "center",
                    width: 100,
                    sortable: false,
                },
            ],
            options : {
                scrollX: false,
                scrollY: false,
                header: { height: 45 },
                rowHeight: 45,
            },
            pageOptions : {},
        }
    },
    computed: {
        ...mapGetters({
            params:     'getParams',
            loginNo:    'getLoginNo',
        }),
        getLoginNo() {
            return this.loginNo || '';
        },
    },
    components: {
        'skp-breadcrumbs' : SKPBreadcrumbs,
        'toast-grid' : ToastGrid
    },
    methods: {
        getSearchParams() {
            const mFormat = localStorage.getItem('mDateFormat');
            let params = {
                strDate : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                endDate : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : ''
            };
            return params;
        },

        // 버튼 이벤트
        async onSearch() {
            let validContents = this.registVerifyContents();
            if (validContents) {
                let params = this.getSearchParams();
                console.log('params ===> ', params);
                SDLUtil.showLoadingBar(true);
                const response = await fetchGridData(params)
                    .then(res => {
                        this.gridData = res.data.result.rowData;
                        this.totalCount = this.gridData.length;
                        this.searchParam = res.data.searchParam;

                        this.$nextTick(() => {
                            this.$refs.GridId.addRowClassName(this.totalCount-1, 'subTotal');
                        });

                        this.gridKey++;
                        SDLUtil.showLoadingBar(false);
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                        SDLUtil.showLoadingBar(false);
                    });
            }
        },
        // 컨텐츠 클릭 이벤트 -> Grid
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;

            let blockCols = '|PROD_NM|SCORE|';
            let row = rowData[e.rowKey];
            let value = Number(eval('row.' + colNm));
            if (value == 0) return;
            if (row.PROD_NM == 'Total') return;
            if (blockCols.indexOf('|' + colNm + '|') > -1) return;

            let headerNm = '';
            this.columns.forEach((elm, idx) => {
                if (elm.name == colNm) {
                    headerNm = elm.header;
                    return;
                }
            });

            let anScore = '';
            if (colNm == 'TOTAL_CNT') {          anScore = 'T'; }
            else if (colNm == 'VERY_GOOD_CNT') { anScore = '5'; }
            else if (colNm == 'GOOD_CNT') {      anScore = '4'; }
            else if (colNm == 'NORMAL_CNT') {    anScore = '3'; }
            else if (colNm == 'BAD_CNT') {       anScore = '2'; }
            else if (colNm == 'VERY_BAD_CNT') {  anScore = '1'; }
            else if (colNm == 'NO_POLL_CNT') {   anScore = '';  }
            else { anScore = ''; }

            let params = this.searchParam; // 목록 조회한 매개변수들..
            params.gbmCd    = row.GBM_CD;
            params.anScore  = anScore;
            params.pageMode = '2'; // Q&A Satisfaction Index by GBM
            params.dynLabel1 = SDLUtil.getMsgProp('FIELD.GLOBAL.GBM');
            params.dynLabel2 = SDLUtil.getMsgProp('FIELD.GLOBAL.SATISFACTION');
            params.dynValue1 = row.PROD_NM;
            params.dynValue2 = headerNm;
            params.btnShow = false;
            params.url = `${SDLUtil.API_URL}/basis/admin/statisticsManager/satisIndexByGBMPops.skp`;

            SDLUtil.show(
                StstLinkPopup, {
                    title: 'title',
                    pParams: params,
                    rtnUserFunc: (arg1) => {
                        console.log('arg1 ==> ', arg1);
                    }
                }, // component params
                {
                    height: 'auto',
                }, // dialog params
            );
        },
        // 엑셀 다운로드
        excelDownload() {
            const startDate = moment(this.rangePicker.getStartDate());
            const endDate = moment(this.rangePicker.getEndDate());
            const dateDiff = Math.abs(endDate.diff(startDate, 'days'));
            if (dateDiff > 31) {
                SDLUtil.alert({
                    title: 'Alert',
                    msg: 'Maximum Period range for Export to Excel is 1 month',
                });
                return;
            }
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    let param = this.getSearchParams();
                    param.colId = 'FIELD.GLOBAL.GBM';
                    param.colNm = 'PROD_NM';
                    param.dynQueryId = 'findByGBM';
                    param.excelFileName = 'SatisfactionIndexByGBM';
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/statisticsManager/qnaSatisfactionIndexByExcel.skp`,
                            qs.stringify(param),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        
        registVerifyContents() {
            let validList = [''];
//            if (SDLUtil.isNull(this.FROM_DATE.getDate())) validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
//            if (SDLUtil.isNull(this.TO_DATE.getDate()))   validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if (validList.length > 1) {
                SDLUtil.alert({
                    msg: 'The following fields are required to start search.' + '<br/>' + '<span class="txt_color1">' + 'Period' + '</span>',
                    class: 'sm_size'
                });
                return false;
            } else {
                return true;
            }
        }
    },
    created() {
        // 초기 카테고리1 리스트 로드
    },
    mounted() {
        
        this.$nextTick(() => {
/*            let toDate = new Date();    
            let fromDate = toDate.setMonth(toDate.getMonth() - 1);
            this.FROM_DATE = DatePicker.create('from-picker-container', 'fromDate', 'icoFromDate', 'en', {} ,fromDate);
            this.TO_DATE   = DatePicker.create('to-picker-container', 'toDate', 'icoToDate', 'en', {} ,new Date());
            console.log('this.FROM_DATE ==> ', this.FROM_DATE);
            console.log('this.TO_DATE ==> ', this.TO_DATE);
*/            
            this.rangePicker = DatePicker.createRangeWithOpener(
                'from-picker-container', 'fromDate', 'icoFromDate',
                'to-picker-container', 'toDate', 'icoToDate',
                { type: 'date', locale: 'en', showToday: false },
                (new moment()).add(-1, 'years').toDate(),
                (new moment()).toDate()
            );
        });
    },
    beforeDestroy() {

    }
};
</script>

<style>
.ftColor { color: dodgerblue!important; font-weight: bold!important; cursor:pointer; }
.ftBold {font-weight: bold!important;}
.subTotal {
  background: #f9f9f9 !important;
  font-weight: bold;
  width: 100% !important;
  height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/byGBMList.vue